<template>
  <div>
    <!-- 轮播 -->
    <div     v-show="!store.getters.getConfig.is_header">
      <Delogin></Delogin>
    </div>
    <div v-show="store.getters.getConfig.is_header">
      <div id="col">
        <a-carousel style="height: 530px" v-if="banners">
          <div v-for="(banner, index) in banners" :key="index" style="height: 530px">
            <div
              class="w-full bg-center bg-cover"
              :style="{
                backgroundImage: `url(${$ossUrl + banner.img_src})`,
                height: '530px',
              }"
              @click="openBlank(banner.url_data, banner.name)"
            ></div>
          </div>
        </a-carousel>
      </div>
      <!-- 企业介绍 -->
      <div id="intr" class="text-center bg-white">
        <div class="max-w-screen-xl m-auto">
          <div class="pt-4 mt-4 title">关于我们</div>
          <div class="table overflow-hidden">
            <div class="table-cell leading-loose text-gray-500 align-middle" style="width: 55%">
              {{ setting.about_us }}
            </div>
            <div class="table-cell" style="width: 45%">
              <img
                :src="`https://zjzbrz.oss-cn-hangzhou.aliyuncs.com/static/default/2022-08-12/28b9dca3-2c4e-4e30-9c2e-f4435fd37a44.jpg`"
                class="w-full"
              />
            </div>
          </div>
        </div>
      </div>
      <!-- 新闻资讯 -->
      <div id="news" class="relative" v-if="newsList.length > 0">
        <div class="relative max-w-screen-xl m-auto">
          <div class="py-4 title">新闻资讯</div>
          <div
            @click="handleGo(`/newss`)"
            class="absolute right-0 inline-block px-3 py-1 border-black rounded cursor-pointer top-6 border-1"
          >
            查看更多>
          </div>
          <div class="gap-6 mt-16 mb-8">
            <img
              :src="`https://zjzbrz.oss-cn-hangzhou.aliyuncs.com/static/default/2022-08-12/93b82329-c4c6-4745-ada7-cb0f66724aaa.png`"
              class="float-left object-cover w-1/3"
            />
            <div
              class="float-left w-1/3 pl-3 text-gray-500"
              v-if="newsList && newsList[newsIndex]"
              @click="handleGo(`/news/${newsList[newsIndex].id}`)"
            >
              <div class="text-base truncate">
                <div class="truncate">{{ newsList[newsIndex].name }}</div>
                <div class="truncate">
                  {{ newsList[newsIndex].push_time.split(' ')[0] }}
                </div>
              </div>
              <div>{{ newsList[newsIndex].intr }}</div>
              <a class="text-gray-500">详细-></a>
            </div>
            <div class="float-left w-1/3">
              <div
                v-for="(n, index) in newsList"
                :key="index"
                class="p-2 mb-2 rounded cursor-pointer hover:bg-blue-500 hover:text-white"
                @mouseover="newsIndex = index"
                @click="handleGo(`/news/${n.id}`)"
              >
                <div class="mr-2 text-sm truncate">{{ n.name }}</div>
                <div class="text-sm text-right" style="min-width: 100px">
                  {{ n.push_time.split(' ')[0] }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 保函项目介绍 -->
      <div id="contract_category" class="relative w-full overflow-hidden bg-white">
        <div
          style="
            background-image: url(https://zjzbrz.oss-cn-hangzhou.aliyuncs.com/static/default/2022-08-12/86227ce0-68a7-4270-8a47-c2b9a3a78716.jpg);
            filter: grayscale(100%);
            opacity: 0.2;
          "
          class="absolute top-0 left-0 w-full bg-cover h-72 -z-1"
        ></div>

        <div class="max-w-screen-xl m-auto">
          <div class="text-3xl py-14">保函服务</div>
          <div class="pb-4">
            <div class="pl-10 mx-32">
              <div
                v-for="(cate, index) in TempCategorys"
                :key="index"
                class="z-10 float-left h-64 mb-10 mr-16 bg-white rounded-lg shadow-2xl"
                style="width: calc(33.3% - 64px)"
              >
                <div class="my-4 text-xl text-center">{{ cate.name }}</div>
                <div class="mx-4 overflow-hidden leading-relaxed text-gray-500 break-words h-28">
                  {{ cate.introduce }}
                </div>
                <div class="mt-6 text-center">
                  <div
                    v-if="cate.review"
                    class="inline-block px-4 py-1 border-2 border-gray-500 rounded-full cursor-pointer"
                    @click="handleGo(`/projects?temp_category_id=${cate.id}`)"
                  >
                    立即申请
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 电子保函申请流程 -->
      <div id="flow" class="p-6 bg-white">
        <div class="py-4 title">电子保函申请流程</div>
        <div class="pt-16">
          <div class="text-center">
            <img
              class="m-auto"
              src="https://zjzbrz.oss-cn-hangzhou.aliyuncs.com/static/default/2022-08-12/13ae047c-0cfe-4794-a977-b9abdebb63d5.jpg"
            />
          </div>
          <div class="py-6 text-center">
            <div
              v-if="!login"
              class="inline px-6 py-2 text-center text-white rounded cursor-pointer bg-gradient-to-r from-blue-700 to-blue-400"
              @click="gotoSign"
            >
              免费注册
            </div>
          </div>
        </div>
      </div>
      <!-- 工程项目 -->
      <div id="project" class="project">
        <div class="w-full max-w-screen-xl px-8 py-24 m-auto">
          <div class="w-full mb-12 text-4xl font-medium text-center text-white"> 热门工程项目 </div>
          <div class="p-2 rounded-t-xl" style="background-color: white">
            <a-table
              :dataSource="projects"
              :columns="columns"
              size="small"
              :pagination="false"
              bordered
            >
              <span slot="action" slot-scope="_, record"
                ><a-button v-if="record.is_bidder" type="primary" disabled>已申请</a-button>
                <a-button v-else type="primary" @click="gotoTemp(record)">申请保函</a-button></span
              >
            </a-table>
          </div>
          <div
            class="p-1 overflow-hidden text-white bg-blue-500 rounded-b-xl"
            style="background-color: #3b82f6"
          >
            <div class="float-left px-2 cursor-pointer">
              <div class="float-left text-lg leading-10" @click="handleGo(`/projects`)">
                查看更多
              </div>
              <div class="float-left text-sm leading-10" @click="handleGo(`/projects`)">
                view more
              </div>
            </div>
            <a-icon
              type="swap-right"
              class="float-right cursor-pointer"
              :style="{ fontSize: '2rem', width: '4rem' }"
              @click="handleGo(`/projects`)"
            />
          </div>
        </div>
      </div>
      <!-- 合作伙伴 -->
      <div id="customer" class="w-full p-6 overflow-hidden bg-white">
        <div class="py-4 title">合作机构</div>
        <div>
          <div class="w-full max-w-screen-xl px-8 py-24 m-auto text-center">
            <!-- <div class="w-full mb-6 text-4xl font-medium text-center">合作机构</div> -->
            <div style="margin: 0 auto; width: 1280px">
              <div
                v-for="(item, index) in partner"
                :key="index"
                class="float-left w-48 px-2 m-2 rounded-lg cusshadow"
              >
                <div
                  class="h-16"
                  :style="{
                    background: `url(${$ossUrl}${item.img_src}) no-repeat`,
                    backgroundSize: 'contain',
                  }"
                />
              </div>
              <div style="float: none; clear: both"></div>
            </div>
          </div>
        </div>
      </div>
      <!-- 资质荣誉 -->
      <div id="license" class="pb-16 bg-white">
        <img
          class="max-w-screen-xl m-auto"
          src="https://zjzbrz.oss-cn-hangzhou.aliyuncs.com/static/default/2022-08-13/6bf8f2a4-530b-4920-aee7-7aec758cf6b4.jpg"
        />
      </div>
    </div>
  </div>
</template>
<script>
  import { carousels } from '@/api/carousel';
  import { temp_categorys } from '@/api/temp';
  import { top_projects } from '@/api/project';
  import { newss } from '@/api/news';
  import { config } from '@/api/config';
  import { partners } from '@/api/partner';
  import Delogin from './delogin/deindex.vue';
  import { columns } from './_index';
  import store from '@/store/index';
  import { mapGetters } from 'vuex';
  export default {
    name: 'Index',
    components: {
      Delogin,
    },
    data() {
      return {
        setting: {},
        banners: [],
        newsList: [],
        TempCategorys: [],
        projects: [],
        partner: [],
        newsIndex: 0,
        columns,
        store: store,
      };
    },
    computed: {
      ...mapGetters(['login']),
    },
    watch: {},
    mounted() {
      this.getNews();
      this.getBanners();
      this.getConfig();
      this.getTempCategorys();
      this.getProject();
      this.getPartners();
    },
    created() {},
    methods: {
      async getBanners() {
        this.banners =
          (
            await carousels()
          ).data || [];
          console.log(this.banners.length)
      },
      async getConfig() {
        this.setting = (await config()) || {};
      },
      async getNews() {
        this.newsList =
          (
            await newss({
              qp: JSON.stringify({ eq: { review: 1 } }),
              pageSize: 5,
            })
          ).data || [];
      },
      async getTempCategorys() {
        this.TempCategorys =
          (await temp_categorys({ orderby: 'review desc,sort desc' })).data || [];
      },
      async getProject() {
        this.projects = (await top_projects()) || [];
      },
      async getPartners() {
        this.partner = (await partners()).data || [];
      },
      openBlank(url, name) {
        url && window.open(url, name, '__blank');
      },
      handleGo(path) {
        this.$router.push(path);
      },
      gotoTemp(record) {
        this.$router.push(`/admin/contract_apply?project_id=${record.id}`);
      },
      gotoSign() {
        this.$store.commit('user/SET_LOGINSTATE', 'SMS_REGISTRY');
        this.$store.commit('user/SET_LOGINFLAG', true);
      },
    },
  };
</script>
<style lang="less" scoped>
  .title {
    position: relative;
    font-size: 32px;
    height: 45px;
    line-height: 45px;
    text-align: center;
  }
  .title:before {
    content: '';
    position: absolute;
    width: 1rem;
    height: 2px;
    top: 85%;
    left: 41%;
    background-color: #808080;
  }
  .title:after {
    content: '';
    position: absolute;
    width: 1rem;
    height: 2px;
    top: 85%;
    right: 41%;
    background-color: #808080;
  }
  .project {
    // height: 900px;
    background-image: url(https://zjzbrz.oss-cn-hangzhou.aliyuncs.com/assets/back3.png);
    background-clip: padding-box;
    background-size: cover;
    background-repeat: no-repeat;
    background-attachment: scroll;
    background-position: center center;
    background-blend-mode: normal;
  }
  .project-node {
    height: 48px;
    font-size: 16px;
    font-weight: 500;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
    cursor: pointer;
    margin-left: 17px;
    margin-right: 17px;
    padding: 0 12px;
  }
  .cusshadow {
    box-shadow: 0 5px 20px 0 rgba(19, 60, 154, 0.08), inset 0 2px 0 0 #fff;
  }
</style>
